module.exports = __webpack_public_path__ + "static/media/exclusive_without_num-1.6efe83d6.png";